import { render, staticRenderFns } from "./dashboard-v2-view.vue?vue&type=template&id=7f3f30cf&scoped=true"
import script from "./dashboard-v2-view.vue?vue&type=script&lang=ts"
export * from "./dashboard-v2-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3f30cf",
  null
  
)

export default component.exports